import { useTranslation } from 'next-i18next';
import useWindowSize from '@hooks/use-window-size';
import Button from '@components/atoms/button/button';
import { State } from '../type';
import styles from '../product-timeline.module.scss';

const ErrorView: React.FC<{
  state: State;
  updateState: (s: State) => void;
}> = ({ state, updateState }) => {
  const { t } = useTranslation('orders-sales');
  const { isWiderThanMd } = useWindowSize();
  return (
    <div className={styles.ordersSales__mainRight__error}>
      <div className={styles.ordersSales__mainRight__error__text}>{t('MY_ACCOUNT.ORDERS_SALES.ERROR.API')}</div>
      {!isWiderThanMd && (
        <Button
          variant="outline"
          size="medium"
          onClick={() => updateState({ ...state, orderProduct: null, saleProduct: null })}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.BACK')}
        </Button>
      )}
    </div>
  );
};

export default ErrorView;
